export enum GroupFilterType {
  /// <summary>
  /// С группами
  /// </summary>
  withGroups = 'withGroups',

  /// <summary>
  /// Без групп
  /// </summary>
  withoutGroups = 'withoutGroups'
}
